/**
 * Whether the client should hydrate #root rather than client-render into it.
 *
 * index.html ships `<div id="root"><!--app-html--></div>` and server.ts swaps
 * that marker for the SSR output, so in production the container always holds
 * server-rendered elements and hydration is correct.
 *
 * `vite dev` does no SSR — its only middleware is the legacy-redirect one — so
 * in dev the container arrives holding nothing but that comment node.
 * Hydrating it threw "Hydration failed because the server rendered HTML didn't
 * match the client" on every route, on every load, which trains everyone to
 * ignore the console on exactly the surface where a real hydration bug would
 * surface first.
 *
 * The discriminator is `firstElementChild`, not `hasChildNodes()`: the
 * un-replaced `<!--app-html-->` comment IS a child node, so `hasChildNodes()`
 * is true in dev and would keep taking the broken path.
 */
export function shouldHydrate(container: Element): boolean {
  return container.firstElementChild !== null;
}
